document.addEventListener('alpine:init', function () {
    Alpine.data('homeBanner', function () {
        return {
            playing: true,
            togglePlay: function () {
                if (this.playing) {
                    this.$refs.video.pause();
                }
                else {
                    this.$refs.video.play();
                }
                this.playing = !this.playing;
            },
        };
    });
});
